"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var _react = _interopRequireWildcard(require("react"));

var _IntlMessages = _interopRequireDefault(require("react-platform-components/dist/Translations/IntlMessages"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useStyle = (0, _core.makeStyles)(function (theme) {
  var _justifyCenter;

  return {
    paperStyle: {
      width: "500px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      padding: "10px",
      top: "240px"
    },
    maxWidth: {
      width: "100%"
    },
    justifyCenter: (_justifyCenter = {}, _defineProperty(_justifyCenter, theme.breakpoints.up(809), {
      display: "flex",
      justifyContent: "center",
      width: "100%"
    }), _defineProperty(_justifyCenter, theme.breakpoints.down(810), {
      width: "fit-content"
    }), _justifyCenter)
  };
});

var CategoryOfProductPopup = function CategoryOfProductPopup(props) {
  var _useState = (0, _react.useState)([]),
      _useState2 = _slicedToArray(_useState, 2),
      openedCollapses = _useState2[0],
      setOpenedCollapses = _useState2[1];

  var classes = useStyle();

  var isChecked = function isChecked(key, id) {
    if (props.values[key] === id) {
      return true;
    } else {
      return false;
    }
  };

  var isOpened = function isOpened(index) {
    return openedCollapses.indexOf(index) !== -1;
  };

  var handleClick = function handleClick(index) {
    var selectedIndex = openedCollapses.indexOf(index);
    var newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(openedCollapses, index);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(openedCollapses.slice(1));
    } else if (selectedIndex === openedCollapses.length - 1) {
      newSelected = newSelected.concat(openedCollapses.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(openedCollapses.slice(0, selectedIndex), openedCollapses.slice(selectedIndex + 1));
    }

    setOpenedCollapses(newSelected);
  };

  var getChildren = function getChildren(category, isParent) {
    // This funtion is used to all of the categories with their children recursevly
    var returnedChildren = [];

    if (isParent) {
      returnedChildren.push(_objectSpread(_objectSpread({}, category), {}, {
        // We apply our recursivity on the sub_categories to get all of it's
        // child categories and so on.
        sub_categories: getChildren(category)
      }));
    } else {
      // We get the children for the given category
      var children = category.sub_categories.map(function (item) {
        return item;
      }); // Then we loop on it's children

      children.forEach(function (item) {
        // We need to get the category from all the categories, because in the sub_categories
        // we only have the id and name
        var currentCategory = props.categories.filter(function (elem) {
          return elem.id === item.id;
        })[0]; // Then we push our category to our array

        returnedChildren.push(_objectSpread(_objectSpread({}, currentCategory), {}, {
          // We apply our recursivity on the sub_categories to get all of it's
          // child categories and so on.
          sub_categories: getChildren(currentCategory)
        }));
      });
    }

    return returnedChildren;
  };

  var organizeCategories = function organizeCategories(categories) {
    var parents = categories.filter(function (cat) {
      return !cat.is_final && !cat.parent_category || cat.is_final && !cat.parent_category;
    });
    return parents.map(function (parent) {
      return getChildren(parent, true)[0];
    });
  };

  var handleCategoryChange = function handleCategoryChange(event) {
    // Set field value
    props.setFieldValue('category', event.target.value); // Run setFieldTouched in a setTimeout to validate field after it's value get's updated

    setTimeout(function () {
      return props.setFieldTouched('category', true);
    });
    props.closePopup();
  };

  var showCategoryFields = function showCategoryFields(categories) {
    return categories.map(function (category, index) {
      if (category.sub_categories && category.sub_categories.length > 0) {
        var isCollapseOpened = isOpened(category.id);
        return /*#__PURE__*/_react.default.createElement("div", {
          key: index
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "flex flex-row items-center"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "flex"
        }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, category.name)), /*#__PURE__*/_react.default.createElement("div", {
          className: "flex justify-end"
        }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
          onClick: function onClick() {
            return handleClick(category.id);
          }
        }, /*#__PURE__*/_react.default.createElement(_core.Icon, null, !isCollapseOpened ? 'keyboard_arrow_down' : 'keyboard_arrow_up')))), /*#__PURE__*/_react.default.createElement(_core.Collapse, {
          className: "pl-4",
          in: isCollapseOpened
        }, category.sub_categories.map(function (cat, index) {
          if (cat.sub_categories && cat.sub_categories.length > 0) {
            return showCategoryFields([cat]);
          }

          var _isChecked = isChecked('category', cat.id);

          return /*#__PURE__*/_react.default.createElement("div", {
            key: index
          }, /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
            className: "mb-0 w-full",
            size: "small",
            control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
              value: cat.id,
              onChange: handleCategoryChange,
              checked: _isChecked
            }),
            label: /*#__PURE__*/_react.default.createElement(_core.Typography, {
              variant: "body2"
            }, cat.name)
          }));
        })));
      } else {
        var _isChecked = isChecked('category', category.id);

        return /*#__PURE__*/_react.default.createElement(_core.FormControlLabel, {
          className: "mb-0",
          key: index,
          control: /*#__PURE__*/_react.default.createElement(_core.Checkbox, {
            value: category.id,
            onChange: handleCategoryChange,
            checked: _isChecked
          }),
          label: /*#__PURE__*/_react.default.createElement(_core.Typography, {
            variant: "body2"
          }, category.name)
        });
      }
    });
  };

  var categories = props.categories;
  var organizedCategories = categories.length > 0 ? organizeCategories(categories) : [];
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    elevation: 3,
    className: classes.paperStyle
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.maxWidth
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.justifyCenter
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: "mb-4",
    variant: "h6"
  }, /*#__PURE__*/_react.default.createElement(_IntlMessages.default, {
    id: "Pick a category",
    defaultMessage: "Pick a category"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "flex flex-col px-4"
  }, showCategoryFields(organizedCategories))));
};

var _default = CategoryOfProductPopup;
exports.default = _default;